define('modules/feedback/feedback',['jquery',
		'text2!modules/feedback/feedback-button.html',
		'text2!modules/feedback/feedback-form.html',
		'wrap!lightbox_me'],
function($,button,form) {
	$(function() {
		var $button = $(button);
		var $form = $(form);
		$button.appendTo('body');

		$button.click(function() {
			$form.lightbox_me({
				overlayCSS:	{background: 'black', opacity: .8},
				centered: true,
				closeClick: false,
				closeSelector:	".close"	
			});
		});

		$form.find('form').submit(function(e){
			e.preventDefault();

			$.post('/contact/?feedback',$(this).serialize());

			$(this).find('#success').fadeIn().delay(1000).fadeOut(2000);
		});
	});
});

